import React, { useState, useEffect } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
  IconButton,
} from "@mui/material";
import {
  Link,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Dashboard from "./Dashboard";
import ManageUsers from "./users/ManageUsers";

import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import LogoutIcon from "@mui/icons-material/Logout";
import LocalGroceryStoreIcon from "@mui/icons-material/LocalGroceryStore";
import ManageStore from "./manageStores/ManageStore";

import SensorOccupiedIcon from "@mui/icons-material/SensorOccupied";
import ManageSupport from "./support/ManageSupport";
import ArticleIcon from "@mui/icons-material/Article";
import ManageArticles from "./articles/ManageArticles";
import SiteInfoMange from "./siteInfo/SiteInfoMange";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { API_BASE_URL } from "../../apiConfig";
import axios from "axios";
import { refreshTokenIfNeeded } from "./refreshTokenIfNeeded";

function AdminDashboard() {
  const location = useLocation();
  const navigate = useNavigate();
  const [count, setCount] = useState(0);

  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    const today = new Date();
    today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
    const formattedDate = today.toISOString().split("T")[0];
    setCurrentDate(formattedDate);
  }, []);

  // const token = localStorage.getItem("token");
  const userName = localStorage.getItem("userName");

  const handleLogout = async () => {
    // let token = localStorage.getItem("token");

    const refresh = localStorage.getItem("refresh");

    try {
      let response = await axios.post(`${API_BASE_URL}Auth/logout`, {
        userName: localStorage.getItem("userName"),
        refreshToken: refresh,
      });
    } catch (err) {
      // alert("Logout failed", err);
    }

    // إزالة كل التوكنات والبيانات
    localStorage.removeItem("token");
    localStorage.removeItem("refresh");
    navigate("/", { replace: true });
  };

  return (
    <>
      <Box
        dir={"rtl"}
        sx={{
          display: "flex",
          height: "100vh",
          //flexDirection: "row",
          backgroundColor: "#5b5b5c",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            position: "absolute",
            top: 10,
            left: 20,
            fontSize: "15px",
            color: "#e6e6e6",
            backgroundColor: "#272727",
          }}
        >
          مرحبا بك.. {userName?.toUpperCase()} | تاريخ اليوم :{" "}
          <span dir="ltr">{currentDate}</span>
        </Typography>

        {/* القائمة الجانبية */}
        <Box
          sx={{
            width: { xs: "40%", sm: "30%", md: "20%", lg: "15%" },
            height: "100vh", // تأكيد تغطية العنصر لكامل ارتفاع الشاشة
            backgroundColor: "#333",
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
            padding: 0, // إزالة أي تعبئة محتملة
            margin: 0, // إزالة أي هوامش محتملة
            boxShadow: "-20px 0px 50px rgba(0, 0, 0, 1)",
          }}
        >
          <div
            style={{
              marginBottom: "10px",
              marginTop: "60px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              src="/logo.png"
              width="170"
              height="auto"
              alt="كوبون أول طلب"
            />
          </div>
          <div style={{ marginBottom: "30px" }}>
            <a
              href="https://couponfirstorder.com"
              target="_blank"
              style={{
                color: "#e6e6e6",
                display: "flex",
                justifyContent: "center",
                fontFamily: "'Changa', sans-serif",
                textDecoration: "none",
                fontSize: "13.5px",
              }}
            >
              اذهب للموقع
            </a>
          </div>
          <hr
            style={{ borderTop: "2px solid #272727", marginBottom: "-5px" }}
          />
          <List>
            <ListItem
              button
              component={Link}
              to="/admin"
              sx={{
                backgroundColor:
                  location.pathname === "/admin" ? "#1779ca" : "inherit",
                width: "100%",
                "&:hover": {
                  backgroundColor: "#1779ca",
                  color: "#fff",
                },
              }}
            >
              <ListItemIcon>
                <DashboardIcon sx={{ color: "white", marginRight: "15%" }} />
              </ListItemIcon>
              <ListItemText
                primary="الرئيسية"
                sx={{
                  color: "white",
                  textAlign: "right",
                }}
              />
            </ListItem>

            <ListItem
              button
              component={Link}
              to="/admin/manage-stores"
              sx={{
                backgroundColor:
                  location.pathname === "/admin/manage-stores"
                    ? "#1779ca"
                    : "inherit",
                width: "100%",
                "&:hover": {
                  backgroundColor: "#1779ca",
                  color: "#fff",
                },
              }}
            >
              <ListItemIcon>
                <LocalGroceryStoreIcon
                  sx={{ color: "white", marginRight: "15%" }}
                />
              </ListItemIcon>
              <ListItemText
                primary="المتاجر"
                sx={{ color: "white", textAlign: "right" }}
              />
            </ListItem>

            <ListItem
              button
              component={Link}
              to="/admin/manage-articles"
              sx={{
                backgroundColor:
                  location.pathname === "/admin/manage-articles"
                    ? "#1779ca"
                    : "inherit",
                width: "100%",
                "&:hover": {
                  backgroundColor: "#1779ca",
                  color: "#fff",
                },
              }}
            >
              <ListItemIcon>
                <ArticleIcon sx={{ color: "white", marginRight: "15%" }} />
              </ListItemIcon>
              <ListItemText
                primary="المدونة"
                sx={{ color: "white", textAlign: "right" }}
              />
            </ListItem>

            <ListItem
              button
              component={Link}
              to="/admin/manage-user"
              sx={{
                backgroundColor:
                  location.pathname === "/admin/manage-user"
                    ? "#1779ca"
                    : "inherit",
                width: "100%",
                "&:hover": {
                  backgroundColor: "#1779ca",
                  color: "#fff",
                },
              }}
            >
              <ListItemIcon>
                <PeopleIcon sx={{ color: "white", marginRight: "15%" }} />
              </ListItemIcon>
              <ListItemText
                primary="المشرفين"
                sx={{ color: "white", textAlign: "right" }}
              />
            </ListItem>

            <ListItem
              button
              component={Link}
              to="/admin/manage-siteinfo"
              sx={{
                backgroundColor:
                  location.pathname === "/admin/manage-siteinfo"
                    ? "#1779ca"
                    : "inherit",
                width: "100%",
                "&:hover": {
                  backgroundColor: "#1779ca",
                  color: "#fff",
                },
              }}
            >
              <ListItemIcon>
                <SettingsApplicationsIcon
                  sx={{ color: "white", marginRight: "15%" }}
                />
              </ListItemIcon>
              <ListItemText
                primary="الإعدادات"
                sx={{ color: "white", textAlign: "right" }}
              />
            </ListItem>

            <ListItem
              button
              component={Link}
              to="/admin/support"
              sx={{
                backgroundColor:
                  location.pathname === "/admin/support"
                    ? "#1779ca"
                    : "inherit",
                width: "100%",
                "&:hover": {
                  backgroundColor: "#1779ca",
                  color: "#fff",
                },
              }}
            >
              <ListItemIcon>
                <SensorOccupiedIcon
                  sx={{ color: "white", marginRight: "15%" }}
                />
              </ListItemIcon>
              <ListItemText
                primary="الدعم الفني"
                sx={{ color: "white", textAlign: "right" }}
              />
            </ListItem>

            {/* زر تسجيل الخروج */}
            <ListItem
              button
              onClick={handleLogout}
              sx={{
                width: "100%",
                "&:hover": {
                  backgroundColor: "#1779ca",
                  color: "#fff",
                },
                cursor: "pointer",
              }}
            >
              <ListItemIcon>
                <LogoutIcon sx={{ color: "white", marginRight: "15%" }} />
              </ListItemIcon>
              <ListItemText
                primary="خروج"
                sx={{ color: "white", textAlign: "right" }}
              />
            </ListItem>
          </List>
        </Box>

        {/* محتوى الصفحات */}
        <Box
          sx={{
            width: { xs: "60%", sm: "70%", md: "80%", lg: "85%" },
            backgroundColor: "#272727",
            padding: 4, // إزالة أي تعبئة محتملة
            margin: 0,
            overflowY: "auto",
          }}
        >
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/manage-siteinfo" element={<SiteInfoMange />} />
            <Route path="/manage-user" element={<ManageUsers />} />
            <Route path="/manage-stores" element={<ManageStore />} />
            <Route path="/manage-articles" element={<ManageArticles />} />
            <Route path="/support" element={<ManageSupport />} />
          </Routes>
        </Box>
        <Typography
          variant="body2"
          sx={{
            position: "absolute",
            bottom: 10,
            left: 10,
            color: "#e6e6e6",
          }}
        >
          كوبون أول طلب
        </Typography>
      </Box>
    </>
  );
}

export default AdminDashboard;

// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemIcon,
//   Typography,
//   IconButton,
// } from "@mui/material";
// import {
//   Link,
//   Route,
//   Routes,
//   useLocation,
//   useNavigate,
// } from "react-router-dom";
// import Dashboard from "./Dashboard";
// import ManageUsers from "./users/ManageUsers";

// import DashboardIcon from "@mui/icons-material/Dashboard";
// import PeopleIcon from "@mui/icons-material/People";
// import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
// import LogoutIcon from "@mui/icons-material/Logout";
// import FmdGoodIcon from "@mui/icons-material/FmdGood";
// import ManageCars from "./manageCars/ManageCars";
// import HandymanIcon from "@mui/icons-material/Handyman";
// import ManageMaintenance from "./manageMaintenance/ManageMaintenance";
// import ManageLocations from "./locations/ManageLocations";
// import { Helmet } from "react-helmet";

// function AdminDashboard() {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [currentDate, setCurrentDate] = useState("");

//   useEffect(() => {
//     const today = new Date();
//     today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
//     const formattedDate = today.toISOString().split("T")[0];
//     setCurrentDate(formattedDate);
//   }, []);

//   const token = localStorage.getItem("token");
//   const userName = localStorage.getItem("userName");

//   if (!token) {
//     // إعادة التوجيه إلى صفحة تسجيل الدخول بشكل مباشر إذا لم يكن التوكن موجودًا
//     return <navigate to="/adminLogin" />;
//   }
//   const handleLogout = () => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("userID");
//     localStorage.removeItem("permissions");

//     navigate("/adminLogin");
//   };

//   return (
//     <>
//       <Helmet>
//         <title>أهلاً بك في لوحة تحكم الأدارة موقع إيجار سيارة</title>
//         <meta
//         //name="description"
//         //content="استئجار سيارات بسهولة وأمان مع عروض مميزة وخدمة عملاء على مدار الساعة."
//         />
//       </Helmet>
//       <Box
//         dir={"rtl"}
//         sx={{ display: "flex", height: "100vh", backgroundColor: "#5b5b5c" }}
//       >
//         <Typography
//           variant="body2"
//           sx={{
//             position: "absolute",
//             top: 10,
//             left: 50,
//             color: "#e6e6e6",
//             backgroundColor: "#272727",
//           }}
//         >
//           مرحبا بك.. {userName.toUpperCase()} | تاريخ اليوم :{" "}
//           <span dir="ltr">{currentDate}</span>
//         </Typography>
//         {/* القائمة الجانبية */}
//         <Box
//           sx={{
//             width: { xs: "40%", sm: "30%", md: "20%", lg: "15%" }, // استجابة للأحجام المختلفة
//             backgroundColor: "#3c3c3c",
//             display: "flex",
//             flexDirection: "column",
//             //height: "103vh",
//             //overflowY: "auto",
//           }}
//         >
//           <div
//             style={{
//               marginBottom: "10px",
//               marginTop: "40px",
//               display: "flex",
//               justifyContent: "center",
//             }}
//           >
//             <img src="/logo.png" width="170" height="50" alt="ايجار سيارة" />
//           </div>
//           <div style={{ marginBottom: "20px" }}>
//             <a
//               href="/"
//               target="_blank"
//               style={{
//                 color: "#e6e6e6",
//                 display: "flex",
//                 justifyContent: "center",
//                 fontFamily: "'Changa', sans-serif",
//                 textDecoration: "none",
//                 fontSize: "13.5px",
//               }}
//             >
//               اذهب للموقع
//             </a>
//           </div>
//           <List>
//             <ListItem
//               button
//               component={Link}
//               to="/admin"
//               sx={{
//                 backgroundColor:
//                   location.pathname === "/admin" ? "#1779ca" : "inherit",
//                 width: "100%",
//                 "&:hover": {
//                   backgroundColor: "#1779ca",
//                   color: "#fff",
//                 },
//               }}
//             >
//               <ListItemIcon>
//                 <DashboardIcon sx={{ color: "white" }} />
//               </ListItemIcon>
//               <ListItemText
//                 primary="الرئيسية"
//                 sx={{ color: "white", textAlign: "right" }}
//               />
//             </ListItem>

//             <ListItem
//               button
//               component={Link}
//               to="/admin/manage-user"
//               sx={{
//                 backgroundColor:
//                   location.pathname === "/admin/manage-user"
//                     ? "#1779ca"
//                     : "inherit",
//                 width: "100%",
//                 "&:hover": {
//                   backgroundColor: "#1779ca",
//                   color: "#fff",
//                 },
//               }}
//             >
//               <ListItemIcon>
//                 <PeopleIcon sx={{ color: "white" }} />
//               </ListItemIcon>
//               <ListItemText
//                 primary="المشرفين"
//                 sx={{ color: "white", textAlign: "right" }}
//               />
//             </ListItem>

//             <ListItem
//               button
//               component={Link}
//               to="/admin/manage-car"
//               sx={{
//                 backgroundColor:
//                   location.pathname === "/admin/manage-car"
//                     ? "#1779ca"
//                     : "inherit",
//                 width: "100%",
//                 "&:hover": {
//                   backgroundColor: "#1779ca",
//                   color: "#fff",
//                 },
//               }}
//             >
//               <ListItemIcon>
//                 <DirectionsCarIcon sx={{ color: "white" }} />
//               </ListItemIcon>
//               <ListItemText
//                 primary="السيارات"
//                 sx={{ color: "white", textAlign: "right" }}
//               />
//             </ListItem>

//             <ListItem
//               button
//               component={Link}
//               to="/admin/maintenance-car"
//               sx={{
//                 backgroundColor:
//                   location.pathname === "/admin/maintenance-car"
//                     ? "#1779ca"
//                     : "inherit",
//                 width: "100%",
//                 "&:hover": {
//                   backgroundColor: "#1779ca",
//                   color: "#fff",
//                 },
//               }}
//             >
//               <ListItemIcon>
//                 <HandymanIcon sx={{ color: "white" }} />
//               </ListItemIcon>
//               <ListItemText
//                 primary="الصيانة"
//                 sx={{ color: "white", textAlign: "right" }}
//               />
//             </ListItem>

//             <ListItem
//               button
//               component={Link}
//               to="/admin/locations"
//               sx={{
//                 backgroundColor:
//                   location.pathname === "/admin/locations"
//                     ? "#1779ca"
//                     : "inherit",
//                 width: "100%",
//                 "&:hover": {
//                   backgroundColor: "#1779ca",
//                   color: "#fff",
//                 },
//               }}
//             >
//               <ListItemIcon>
//                 <FmdGoodIcon sx={{ color: "white" }} />
//               </ListItemIcon>
//               <ListItemText
//                 primary="الفروع"
//                 sx={{ color: "white", textAlign: "right" }}
//               />
//             </ListItem>

//             {/* زر تسجيل الخروج */}
//             <ListItem
//               button
//               onClick={handleLogout}
//               sx={{
//                 width: "100%",
//                 "&:hover": {
//                   backgroundColor: "#1779ca",
//                   color: "#fff",
//                 },
//                 cursor: "pointer",
//               }}
//             >
//               <ListItemIcon>
//                 <LogoutIcon sx={{ color: "white" }} />
//               </ListItemIcon>
//               <ListItemText
//                 primary="خروج"
//                 sx={{ color: "white", textAlign: "right" }}
//               />
//             </ListItem>
//           </List>
//         </Box>

//         {/* محتوى الصفحات */}
//         <Box
//           sx={{
//             width: { xs: "60%", sm: "70%", md: "80%", lg: "85%" },
//             backgroundColor: "#272727",
//             padding: 4,
//             height: "93vh", // ضبط ارتفاع الحاوية ليغطي كامل الشاشة
//             overflowY: "auto",
//           }}
//         >
//           <Routes>
//             <Route path="/" element={<Dashboard />} />
//             <Route path="/manage-user" element={<ManageUsers />} />
//             <Route path="/manage-car" element={<ManageCars />} />
//             <Route path="/maintenance-car" element={<ManageMaintenance />} />
//             <Route path="/locations" element={<ManageLocations />} />
//           </Routes>
//         </Box>
//         <Typography
//           variant="body2"
//           sx={{
//             position: "absolute",
//             bottom: 10,
//             right: 10,
//             color: "#e6e6e6",
//           }}
//         >
//           © برنامج إيجار سيارة
//         </Typography>
//       </Box>
//     </>
//   );
// }

// export default AdminDashboard;
